import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { IconButton, Text } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

import { Palette, radius, spacing, useThemePalette } from '../../theme';

interface RepeatableItemCardProps {
  title: string;
  onRemove: () => void;
  children: React.ReactNode;
}

const RepeatableItemCard: React.FC<RepeatableItemCardProps> = ({
  title,
  onRemove,
  children,
}) => {
  const { t } = useTranslation();
  const palette = useThemePalette();
  const styles = useMemo(() => makeStyles(palette), [palette]);

  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <Text style={styles.title} numberOfLines={1}>
          {title}
        </Text>
        <IconButton
          icon="delete-outline"
          size={20}
          onPress={onRemove}
          iconColor={palette.danger}
          accessibilityLabel={t('resume.buttons.remove')}
        />
      </View>
      <View style={styles.body}>{children}</View>
    </View>
  );
};

const makeStyles = (p: Palette) =>
  StyleSheet.create({
    card: {
      borderRadius: radius.md,
      backgroundColor: p.surfaceMuted,
      borderWidth: 1,
      borderColor: p.border,
      marginBottom: spacing.md,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: spacing.md,
      paddingRight: spacing.xs,
    },
    title: { flex: 1, color: p.textPrimary, fontWeight: '700', fontSize: 14 },
    body: { padding: spacing.md, paddingTop: 0, gap: spacing.sm },
  });

export default RepeatableItemCard;
